import React, { FC, useCallback, useMemo } from 'react';
import {
  Picture,
  PictureMode,
} from '@wix/wix-vod-shared/dist/src/common/components/picture';
import { VideoAspectRatio } from '../../../../../common/components/VideoAspectRatio/VideoAspectRatio';
import {
  GqlVideoFragment,
  GqlVideoSource,
} from '../../../../../apollo/generated/graphql';
import s from './Thumbnail.scss';
import {
  usePlayback,
  useSelectedVideo,
  useVideoPricing,
} from '../../../../../hooks';
import { isChannelViewVar } from '../../../../../hooks/useOverlayProps';
import { ThumbnailPlayButton } from '../../../../../common/components/ThumbnailPlayButton/ThumbnailPlayButton';
import { useDuration } from '../../../../../hooks/useDuration';
import { CurrencySign } from '@wix/wix-vod-shared/dist/src/common/components/currency-sign';
import { SHOW_INFO_VALUES } from '@wix/wix-vod-constants/dist/app-settings/show-info-values';
import classNames from 'classnames';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../../../stylesParams';
import { useVideoPlayback } from '../../../../../hooks/useVideoPlayback';
import CalendarSmallIcon from 'wix-ui-icons-common/on-stage/CalendarSmall';

type Props = {
  video: GqlVideoFragment;
};

export const Thumbnail: FC<Props> = ({ video }) => {
  const { selectVideo } = useSelectedVideo();
  const { pause } = usePlayback();
  const videoPlayback = useVideoPlayback(video);
  const styles = useStyles();
  const duration = useDuration(video.content?.duration);
  const { currency } = useVideoPricing(video);
  const src = video.cover.selected;

  const showInfoAction = useMemo(
    () => styles.get(stylesParams.showInfoAction),
    [styles],
  );

  const handleOverlayClick = useCallback(() => {
    isChannelViewVar(false);
    pause();
    selectVideo(video);
  }, [pause, selectVideo, video]);

  return (
    <div className={s.root} onClick={handleOverlayClick}>
      <VideoAspectRatio>
        {src && <Picture src={src} mode={PictureMode.CONTAIN} />}
        <div
          className={classNames(s.overlay, {
            [s.showOverlayOnHover]:
              showInfoAction === SHOW_INFO_VALUES.ON_MOUSE_OVER,
          })}
        >
          <div className={s.header}>{video.title}</div>
          {videoPlayback && (
            <div className={s.center}>
              <ThumbnailPlayButton onClick={videoPlayback.playVideo} />
            </div>
          )}
          <span className={s.leftCorner}>
            {video.source === GqlVideoSource.Live ? (
              <CalendarSmallIcon />
            ) : (
              duration
            )}
          </span>
          {currency && (
            <span className={s.currency}>
              <CurrencySign currency={currency as any} />
            </span>
          )}
        </div>
      </VideoAspectRatio>
    </div>
  );
};
